import { createTheme } from '@mui/material/styles'

// Clean Light Zinc & Indigo Palette
const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#2563eb', // Indigo 600
      dark: '#1e40af',
      light: '#60a5fa',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#64748b', // Slate 500
      dark: '#475569',
      light: '#94a3b8'
    },
    background: {
      default: '#f8fafc', // Slate 50 (Off-white)
      paper: '#ffffff' // White
    },
    text: {
      primary: '#0f172a', // Slate 900
      secondary: '#64748b' // Slate 500
    },
    divider: '#e2e8f0', // Slate 200
    action: {
      selected: 'rgba(0, 0, 0, 0.08)' // Light gray background for booking badges
    }
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    allVariants: {
      color: '#0f172a'
    },
    subtitle2: {
      color: '#2563eb'
    },
    caption: {
      fontSize: '0.75rem',
      fontWeight: 500
    },
    body2: {
      fontSize: '0.875rem',
      fontWeight: 400
    }
  },
  shape: {
    borderRadius: 8
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#e2e8f0'
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#cbd5e1'
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#2563eb'
          }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: '8px'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow:
            '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)', // Subtle shadow
          borderRadius: '8px',
          border: '1px solid #e2e8f0'
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: '#f1f5f9'
          },
          '&.Mui-selected': {
            backgroundColor: '#eff6ff',
            '&:hover': {
              backgroundColor: '#dbeafe'
            }
          }
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#cbd5e1',
          '&.Mui-checked': {
            color: '#2563eb'
          }
        }
      }
    },
    MuiCssBaseline: {
      styleOverrides: {
        '.booking-badge': {
          backgroundColor: 'rgba(0, 0, 0, 0.08)',
          color: 'rgba(0, 0, 0, 0.7)',
          border: '1px solid rgba(0, 0, 0, 0.15)'
        },
        '.calendar-controls': {
          backgroundColor: 'rgba(0, 0, 0, 0.03)'
        },
        '.booking-expand-chip': {
          backgroundColor: '#e2e8f0 !important',
          color: '#0f172a !important',
          '&:hover': {
            backgroundColor: '#cbd5e1 !important'
          }
        },
        '.office-drawing-editor': {
          minHeight: '400px',
          backgroundColor: '#ffffff',
          border: '1px solid #e2e8f0',
          borderRadius: '8px',
          overflow: 'hidden'
        },
        '.office-drawing-viewer': {
          minHeight: '300px',
          backgroundColor: '#ffffff',
          border: '1px solid #e2e8f0',
          borderRadius: '8px',
          overflow: 'hidden'
        }
      }
    }
  }
})

export default lightTheme
